// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/styles
import {
  page,
  main,
  section,
  container,
  title,
  description,
  mlAuto,
  mrAuto
} from 'styles/jss/original/base';
import customCheckboxRadioSwitch from 'styles/jss/original/components/common/ui/customCheckboxRadioSwitchStyle';
import customSelectStyle from 'styles/jss/original/components/common/ui/customSelectStyle';

const styles = {
  page,
  section: {
    ...section,
    padding: '80px 0 40px',
    '@media (min-width: 1024px)': {
      padding: '60px 0 40px'
    },
    '@media (max-width: 992px)': {
      padding: '60px 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '40px 0 20px'
    }
  },
  main: {
    ...main,
    flexGrow: '1'
  },
  mlAuto,
  mrAuto,
  container,
  ...customSelectStyle,
  ...customCheckboxRadioSwitch,
  titleLevel2: {
    ...title,
    textAlign: 'center',
    fontSize: '2.25rem',
    marginBottom: '30px',
    '@media (max-width: 640px)': {
      fontSize: '1.8rem',
      marginBottom: '20px',
      marginTop: '20px'
    },
    '@media (max-width: 320px)': {
      fontSize: '1.6rem',
      marginBottom: '15px'
    }
  },
  textCenter: {
    textAlign: 'center'
  },
  submitButton: {
    marginTop: '30px'
  },
  description: {
    ...description,
    padding: '20px 0 30px',
    textAlign: 'center'
  }
};

export default styles;
